<template>
  <button
    @click.prevent="clicked()"
    :disabled="loading || disabled"
    class="btn d-flex align-items-center justify-content-center rounded-5"
    :class="[
      {
        'w-100': fullWidth,
        'btn-sm': small,
        'my-3': marginVertical,
      },
      btnColor,
    ]"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
    <i :class="leftIcon" v-if="leftIcon" class="me-2 text-action" />
    <!-- TODO: Arrumar o hover quando tiver imagem  -->

    <slot name="leftImg" v-if="$slots.leftImg" />

    <p class="mb-0 text-action">{{ label }}</p>

    <i :class="rightIcon" v-if="rightIcon" class="ms-2 text-action" />

    <slot name="rightImg" v-if="$slots.rightImg" />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    fullWidth?: boolean;
    small?: boolean;
    loading?: boolean;
    outline?: boolean;
    marginVertical?: boolean;
    label?: string;
    color?: string;
    outlineColor?: string;
    leftIcon?: string;
    rightIcon?: string;
  }>(),
  {
    disabled: false,
    fullWidth: false,
    small: false,
    loading: false,
    outline: false,
    marginVertical: true,
    label: "Button Label",
    color: "secondary",
    outlineColor: "primary",
    leftIcon: "",
    rightIcon: "",
  },
);

const emit = defineEmits<{
  onClick: [];
}>();

const btnColor = computed(() =>
  props.outline ? `btn-outline-${props.outlineColor}` : `btn-${props.color}`,
);

const clicked = () => {
  if (props.disabled) return;
  emit("onClick");
};
</script>
